<form>
    <mat-form-field class="items-list">
        <mat-label>{{selectName}}</mat-label>
        <mat-chip-grid #chipGrid [attr.aria-label]="selectName + ' selection'">
            <mat-chip-row *ngFor="let item of items" (removed)="remove(item)">
                {{item.name}}
                <button matChipRemove [attr.aria-label]="'remove ' + item.name">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        </mat-chip-grid>
        <input [placeholder]="'New ' + selectName + '...'" #itemInput [formControl]="itemCtrl" [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let item of filteredItems | async" [value]="item.id">
                {{item.name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</form>